var ContentSystem;
(function (ContentSystem) {
    ContentSystem["OpenContent"] = "OpenContent";
})(ContentSystem || (ContentSystem = {}));
var SiteId;
(function (SiteId) {
    SiteId["Iltalehti"] = "il";
})(SiteId || (SiteId = {}));
function trimQuery(query) {
    return query
        .replace(/#.*\n/g, "")
        .replace(/[\s|,]*\n+[\s|,]*/g, " ")
        .replace(/:\s/g, ":")
        .replace(/,\s/g, ",")
        .replace(/\)\s\{/g, "){")
        .replace(/\}\s/g, "}")
        .replace(/\{\s/g, "{")
        .replace(/\s\}/g, "}")
        .replace(/\s\{/g, "{")
        .replace(/\)\s/g, ")")
        .replace(/\(\s/g, "(")
        .replace(/\s\)/g, ")")
        .replace(/\s\(/g, "(")
        .replace(/=\s/g, "=")
        .replace(/\s=/g, "=")
        .replace(/@\s/g, "@")
        .replace(/\s@/g, "@")
        .replace(/\s\$/g, "$")
        .replace(/\s\./g, ".")
        .trim();
}
function makeQuery(cid, system, siteId, url, issuedAt) {
    return trimQuery(`query {
    contentMeta(
      contents: {
        cid: "${cid}"
        system: ${system}
        siteId: "${siteId}"
        url: "${url}"
        issuedAt: "${issuedAt}"
      }
    ) {
      content {
        keywords {
          leikiHighDef {
            name
            properties {
              relevance
            }
          }
          iabTier1 {
            name
            properties {
              relevance
            }
          }
          iabTier2 {
            name
            properties {
              relevance
            }
          }
          location {
            city
            region
          }
        }
      }
    }
  }
  `);
}
export { makeQuery, ContentSystem, SiteId };
//# sourceMappingURL=query.js.map